var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4299 16.0303C34.4299 21.2035 30.2226 25.3986 25.0308 25.3986C19.8391 25.3986 15.6318 21.2035 15.6318 16.0303C15.6318 10.8572 19.8391 6.66211 25.0308 6.66211C30.2226 6.66211 34.4299 10.8572 34.4299 16.0303Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7745 6.38133C45.7745 9.76308 42.9787 12.5127 39.5198 12.5127C36.061 12.5127 33.2652 9.76308 33.2652 6.38133C33.2652 2.99958 36.061 0.25 39.5198 0.25C42.9787 0.25 45.7745 2.99958 45.7745 6.38133Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9198 6.38133C16.9198 9.76308 14.124 12.5127 10.6651 12.5127C7.20626 12.5127 4.41049 9.76308 4.41049 6.38133C4.41049 2.99958 7.20626 0.25 10.6651 0.25C14.124 0.25 16.9198 2.99958 16.9198 6.38133Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3619 44.7927C37.3619 44.7927 13.9637 44.6456 12.9772 44.7927C11.9908 44.9399 7.66922 43.3382 7.48988 39.1513C7.45177 35.3813 7.63138 33.3169 8.8463 29.6255C10.3744 26.2013 11.6314 24.229 16.2141 24.0149C19.8612 26.2733 21.2841 27.4901 25.4316 27.5601C29.1883 27.2026 30.8378 26.0318 33.8167 24.0149C37.8463 24.2957 39.5246 25.4585 41.3079 29.6255C42.3268 32.1477 42.5668 34.2224 42.6951 39.1821C42.1397 42.2985 41.0644 43.7077 37.3619 44.7927Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9329 14.3657C10.6407 15.2715 8.51567 15.1247 4.22213 12.8243C2.60347 12.7197 1.72528 14.1096 1.13937 18.1575C0.930122 20.6359 0.978541 22.8936 1.13936 22.6583C1.64037 24.2103 2.31346 25.0277 5.05448 25.6178H9.27788C11.4338 23.2533 12.9331 22.6966 15.875 22.4117C13.6507 18.7977 13.8575 17.2181 13.9329 14.3657Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0671 14.3095C39.3593 15.2153 41.4843 15.0685 45.7779 12.7681C47.3965 12.6636 48.2747 14.0535 48.8606 18.1013C49.0699 20.5798 49.0215 22.8374 48.8606 22.6022C48.3596 24.1542 47.6865 24.9716 44.9455 25.5616H40.7221C38.5662 23.1972 37.0669 22.6404 34.125 22.3555C36.3493 18.7416 36.1425 17.1619 36.0671 14.3095Z",
    stroke: "black",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.298b5d0a9b49b033cf7b6ec997c3ad02.svg";
export { ForwardRef as ReactComponent };